const menuItems =[  {   title:"Accueil", target:"#accueil"},
                    {   title:"Presentation", target:"#presentation"},
                    {   title:"Contact",  target:"#contact"}               
            ];

export default menuItems;